// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"Table_tableContainer__rcKTm","table":"Table_table__ZHvKz"};